import { render, staticRenderFns } from "./doctorDetail.vue?vue&type=template&id=ae4f13e2&scoped=true"
import script from "./doctorDetail.vue?vue&type=script&lang=ts"
export * from "./doctorDetail.vue?vue&type=script&lang=ts"
import style0 from "./doctorDetail.vue?vue&type=style&index=0&id=ae4f13e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4f13e2",
  null
  
)

export default component.exports